import { CommonModule } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, Input, OnDestroy, ViewChild } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { AssetUIModel, ClientCoreModule } from '@thehubz/client/core';
import { CreateAssetDto } from '@thehubz/client/data-access-api';
import { Subscription, interval, take } from 'rxjs';

@Component({
  selector: 'thehubz-asset-power-point',
  templateUrl: './asset-power-point.component.html',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatProgressSpinnerModule, ClientCoreModule],
})
export class AssetPowerPointComponent implements AfterViewInit, OnDestroy {
  @ViewChild('iframeRef', { static: false }) iframeRef!: ElementRef;
  @Input() asset!: AssetUIModel;

  docLoading = false;
  iframeUrl?: string;

  private checkIFrameSubscription!: Subscription;

  constructor(private cdRef: ChangeDetectorRef) {}

  ngAfterViewInit() {
    this.checkIfIframeLoaded();
  }

  checkIfIframeLoaded() {
    if (this.asset.assetType === CreateAssetDto.AssetTypeEnum.PowerpointPresentation) {
      this.iframeUrl = this.asset.previewUrl;
      this.docLoading = true;
      this.cdRef.detectChanges();
      const iframeref = this.iframeRef;
      let iframe = iframeref ? iframeref.nativeElement : null;
      this.checkIFrame(iframe);
      this.checkIFrameSubscription = interval(5000)
        .pipe(take(Math.round(20000 / 3000)))
        .subscribe(() => {
          if (iframe == null) {
            iframe = iframeref ? iframeref.nativeElement : null;
            this.checkIFrame(iframe);
          }
          this.reloadIFrame(iframe);
        });
    }
  }

  reloadIFrame(iframe: any) {
    if (iframe) {
      iframe.src = this.iframeUrl;
    }
  }

  checkIFrame(iframe: any) {
    if (iframe) {
      iframe.onload = () => {
        if (this.checkIFrameSubscription) {
          this.docLoading = false;
          this.checkIFrameSubscription.unsubscribe();
        }
      };
    }
  }

  ngOnDestroy(): void {
    this.checkIFrameSubscription && this.checkIFrameSubscription.unsubscribe();
  }
}
